'use client';
import { Card } from '@osmosis/tailwind-ui/components/Card';
import { Prose } from '@osmosis/tailwind-ui/components/Prose';
import React, { useEffect, useRef } from 'react';

type Props = {
  summary: string[];
};
/**
 * Video summary.
 */
export default function VideoSummary(props: Props): JSX.Element | null {
  const { summary } = props;

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(
    () => () => {
      timerRef.current && clearTimeout(timerRef.current);
    },
    [],
  );

  return summary?.[0] ? (
    <Card data-testid="learn-block-wrapper" className="relative">
      <Prose data-testid="transcript-summary-block" content={summary[0]} />
    </Card>
  ) : null;
}
